export type OpenInvitationPost = {
    linkName: string;
    description: string;
    folderId: string;
    jobId: string;
    languageCode: string;
    linkContactInfo?: {
        firstName: string;
        lastName: string;
        email: string;
    };
    personType: string;
    emailNotificationsSetting: {
        notifyAssessmentTaker: boolean;
        includeBAReportInAssessmentTakerEmail: boolean;
        includeSnapshotInAssessmentTakerEmail: boolean;
        notifyAssessmentSender: boolean;
        includeBAReportInLinkSenderEmail: boolean;
        stakeholderEmails: string;
        notifyStakeholders: boolean;
        includeBAReportInStakeholderEmail: boolean;
        stakeholderNotifications?: StakeholderNotificationInfo[];
    };
    isKioskMode: boolean;
    redirectUrl: string;
    webhookUrl: string;
    sendCognitiveAssessmentAfterBA: boolean;
    isMigrated: boolean;
    oi3Version?: string;
    linkType?: OpenInvitationLinkType;
};

export type OpenInvitationPatch = {
    linkName?: string;
    description?: string;
    folderId?: string;
    jobId?: string;
    languageCode?: string;
    linkContactInfo?: {
        firstName: string;
        lastName: string;
        email: string;
    };
    personType?: string;
    notifyAssessmentTaker?: boolean;
    includeBAReportInAssessmentTakerEmail?: boolean;
    includeSnapshotInAssessmentTakerEmail?: boolean;
    notifyAssessmentSender?: boolean;
    includeBAReportInLinkSenderEmail?: boolean;
    stakeholderEmails?: string;
    notifyStakeholders?: boolean;
    includeBAReportInStakeholderEmail?: boolean;
    isKioskMode?: boolean;
    redirectUrl?: string;
    webhookUrl?: string;
    sendCognitiveAssessmentAfterBA?: boolean;
    isMigrated?: boolean;
    oi3Version?: string;
    linkType?: OpenInvitationLinkType;
    emailNotificationsSetting?: {
        notifyAssessmentTaker: boolean;
        includeBAReportInAssessmentTakerEmail: boolean;
        includeSnapshotInAssessmentTakerEmail: boolean;
        notifyAssessmentSender: boolean;
        includeBAReportInLinkSenderEmail: boolean;
        stakeholderEmails: string;
        notifyStakeholders: boolean;
        includeBAReportInStakeholderEmail: boolean;
        stakeholderNotifications?: StakeholderNotificationInfo[];
    };
};

export type OpenInvitationClearPatch = {
    clearJobId: boolean;
    clearStakeholderEmails: boolean;
    clearRedirectUrl: boolean;
    clearWebhookUrl: boolean;
};

export type OpenInvitationServerEntry = {
    id: string;
    linkName: string;
    description: string;
    linkUrl: string;
    companyId: string;
    folderId: string;
    jobId: string;
    jobName: string;
    languageCode: string;
    linkContactInfo: {
        firstName: string;
        lastName: string;
        email: string;
    };
    personType: string;
    emailNotificationsSetting: {
        notifyAssessmentTaker: boolean;
        includeBAReportInAssessmentTakerEmail: boolean;
        includeSnapshotInAssessmentTakerEmail: boolean;
        notifyAssessmentSender: boolean;
        includeBAReportInLinkSenderEmail: boolean;
        stakeholderEmails: string;
        notifyStakeholders: boolean;
        // missing from server - talk to Enyi
        includeBAReportInStakeholderEmail: boolean;
    };
    isKioskMode: boolean;
    redirectUrl: string;
    webhookUrl: string;
    sendCognitiveAssessmentAfterBA: boolean;
    isMigrated: boolean;
    createdBy: string;
    createdByInfo: {
        firstName: string;
        lastName: string;
        email: string;
    };
    createdTime: string;
    modifiedBy: string;
    modifiedByInfo: {
        firstName: string;
        lastName: string;
        email: string;
    };
    modifiedTime: string;
    linkType: OpenInvitationLinkType;
};

// Match to Server
export enum OpenInvitationLinkType {
    Unknown = 0,
    SellerLink
}

// Match to Server
export enum OpenInvitationNotificationType {
    None,
    Email,
    EmailAndBAReport
}

export type StakeholderNotificationInfo = {
    email: string;
    isDeleted: boolean;
    notificationType: OpenInvitationNotificationType;
};
